export enum USER_ROLES {
    TEAM_LEAD = "TEAM_LEAD",
    TEAM_MEMBER = "TEAM_MEMBER"
  }